






































import { Component, Prop, Vue } from 'vue-property-decorator'
import RangeSlider from '@/components/common/rangeSlider/RangeSlider.vue'
import { IpulseSortingStatement, IpulseStatement } from '@/interfaces'
import SimpleConfirmModal from '@/components/modals/SimpleConfirmModal.vue'

@Component({
  name: 'RangeSliderSortingStatement',
  components: {
    RangeSlider,
    SimpleConfirmModal
  }
})

export default class RangeSliderSortingStatement extends Vue {
  @Prop({ default: null })
  statements!: IpulseStatement[]

  values: IpulseSortingStatement[] = []
  options: string[] = [
    'Disagree',
    'Somewhat Agree',
    'Agree',
    'Strongly Agree'
  ]

  created () {
    this.values = this.statements.map(value => {
      return {
        statementId: value.id,
        score: 1
      }
    })
  }

  updateValues (value: string, key: number) {
    const found = this.values.find((item) => {
      return item.statementId === key
    })

    if (found) {
      found.score = Number(value)
    }
  }

  updateOrder (): void {
    const unScoredStatement: IpulseSortingStatement | undefined = this.values.find(
      (statement: IpulseSortingStatement): boolean => {
        return statement.score === 1
      }
    )

    if (unScoredStatement) {
      this.$modal.show('confirm-statements-modal')

      return
    }

    this.confirmUpdateOrder()
  }

  confirmModal (): void {
    this.hideConfirmModal()
    this.confirmUpdateOrder()
  }

  confirmUpdateOrder (): void {
    this.$emit('update-order', this.values)
  }

  hideConfirmModal (): void {
    this.$modal.hide('confirm-statements-modal')
  }
}
